module.exports = __webpack_public_path__ + "static/357-843d2a1fe5a38f23bc16d10bc0822f0f.jpg";